import {ChangeDetectorRef, Component, Input} from '@angular/core';
import {AbstractVisbosControl} from "../../../core/visbos-core/ui/forms/abstract-visbos-control";
import {FormArray, FormBuilder, FormGroup, Validators} from "@angular/forms";
import {IModel} from "../../../shared/view-model/imodel.interface";
import {SessionActions} from "../../../shared/actions";
import {Medicine} from "../../model/medicine.type";
import {PackingUnit} from "../../../shared/view-model/store-management/packing-unit.type";

@Component({
  selector: 'vb-import-medicines-form',
  templateUrl: './import-medicines-form.component.html',
  styleUrls: ['./import-medicines-form.component.css']
})
export class ImportMedicinesFormComponent extends AbstractVisbosControl<IModel, FormGroup> {

  get medicines(): Medicine[] {
    return this._medicines;
  }

  @Input()
  set medicines(value: Medicine[]) {
    this._medicines = value;
    if (!this.control) {
      this.control = this.buildControlContent();
    }
    this.initMedicineData(this._medicines);
  }

  private _medicines: Medicine[] = [];

  selectedPackingUnit: { [p: string]: PackingUnit } = {};

  constructor(fb: FormBuilder, cd: ChangeDetectorRef, sessionActions: SessionActions) {
    super(fb, cd, sessionActions);
  }

  ngOnInit(): void {
    super.ngOnInit();
    this.selectedPackingUnit = {};
  }

  buildControlContent(values?: IModel): FormGroup {
    return ImportMedicinesFormComponent.initControl(this.fb);
  }

  public static initControl(fb: FormBuilder): FormGroup {

    let ctrl = fb.group({
      administration_unit_id: [null],
      supplier_id: [null, Validators.required],
      medicine_data: fb.array([])
    });

    return ctrl;
  }

  public initMedicineData(medicines: Medicine[]): void {

    let ctrl: FormArray = this.control.get('medicine_data') as FormArray;
    ctrl.controls = [];

    for (let med of medicines) {
      ctrl.push(this.fb.group({
        medicine_id: [this.setValue(med, 'cuid'), Validators.required],
        packing_unit_id: [null],
        packing_amount: [null],
        article_number: [null]
      }))
    }

  }

  onPackingUnitSelected(id: number, pu?: PackingUnit) {
    this.selectedPackingUnit[id] = pu;
  }

  setDefaultValues(item?: IModel): { [p: string]: any } | any {
    let ctrl = {
      administration_unit_id: this.activeAdminUnitCuid,
      supplier_id: null
    };

    return ctrl;
  }

}



// WEBPACK FOOTER //
// ./src/app/store-management/medicine/import-medicines-form/import-medicines-form.component.ts